(function () {
  'use strict';

  function productHandle(value) {
    var text = String(value || '').trim();

    if (!text) {
      return '';
    }

    var match = text.match(/\/products\/([^/?#]+)/i);

    if (match) {
      return decodeURIComponent(match[1]);
    }

    return text
      .replace(/^\/+|\/+$/g, '')
      .split('?')[0]
      .split('#')[0];
  }

  function chosenHandles(root) {
    var list = root.closest('.sandelfe-mobile-workshop')
      .querySelector('.sf-workshop-product-links');

    if (!list) {
      return [];
    }

    return list.textContent
      .split(/\r?\n/)
      .map(productHandle)
      .filter(function (handle, index, handles) {
        return handle && handles.indexOf(handle) === index;
      });
  }

  function imageUrl(product) {
    var featured = product.featured_image;

    if (featured) {
      return typeof featured === 'string' ? featured : featured.src;
    }

    if (product.images && product.images.length) {
      return typeof product.images[0] === 'string'
        ? product.images[0]
        : product.images[0].src;
    }

    return '';
  }

  function addCard(track, product, productRoot) {
    var image = imageUrl(product);

    if (!image) {
      return;
    }

    var item = document.createElement('div');
    item.className = 'sf-motif';

    var link = document.createElement('a');
    link.href = productRoot + encodeURIComponent(product.handle);
    link.setAttribute('aria-label', product.title);

    var img = document.createElement('img');
    img.src = image;
    img.alt = product.title;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 300;
    img.height = 300;

    link.appendChild(img);
    item.appendChild(link);
    track.appendChild(item);
  }

  async function fetchAllProducts(collectionUrl) {
    var all = [];

    for (var page = 1; page <= 4; page += 1) {
      var separator = collectionUrl.indexOf('?') === -1 ? '?' : '&';
      var response = await fetch(
        collectionUrl + separator + 'limit=250&page=' + page,
        { credentials: 'same-origin' }
      );

      if (!response.ok) {
        throw new Error('Produkte konnten nicht geladen werden.');
      }

      var data = await response.json();
      var products = data.products || [];

      all = all.concat(products);

      if (products.length < 250) {
        break;
      }
    }

    return all;
  }

  function initialize(root) {
    if (root.dataset.sfInitialized === 'true') {
      return;
    }

    root.dataset.sfInitialized = 'true';

    var track = root.querySelector('.sf-carousel');
    var previousButton = root.querySelector('.sf-carousel-prev');
    var nextButton = root.querySelector('.sf-carousel-next');
    var status = root.parentElement.querySelector('.sf-carousel-status');
    var collectionUrl = root.dataset.collectionUrl;
    var productRoot = root.dataset.productRoot;

    if (!track || !previousButton || !nextButton || !status || !collectionUrl) {
      return;
    }

    function scrollAmount() {
      return Math.max(track.clientWidth * 0.82, 260);
    }

    function updateButtons() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      previousButton.disabled = track.scrollLeft <= 3;
      nextButton.disabled = track.scrollLeft >= maxScroll - 3;
    }

    previousButton.addEventListener('click', function () {
      track.scrollBy({
        left: -scrollAmount(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', function () {
      track.scrollBy({
        left: scrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    }, { passive: true });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        track.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        track.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });
      }
    });

    window.addEventListener('resize', updateButtons);

    fetchAllProducts(collectionUrl)
      .then(function (products) {
        var requested = chosenHandles(root);
        var displayProducts = products;

        if (requested.length) {
          var byHandle = {};

          products.forEach(function (product) {
            byHandle[product.handle] = product;
          });

          displayProducts = requested
            .map(function (handle) {
              return byHandle[handle];
            })
            .filter(Boolean);
        }

        displayProducts.forEach(function (product) {
          addCard(track, product, productRoot);
        });

        if (!displayProducts.length) {
          status.textContent = 'Für das Karussell wurden noch keine Motive gefunden.';
        } else if (requested.length) {
          status.textContent = displayProducts.length + ' ausgewählte Motive';
        } else {
          status.textContent = displayProducts.length + ' Motive';
        }

        updateButtons();
      })
      .catch(function () {
        status.textContent = 'Das Motivkarussell konnte nicht geladen werden.';
        previousButton.disabled = true;
        nextButton.disabled = true;
      });
  }

  function initializeAll() {
    document.querySelectorAll('[data-sf-workshop-carousel]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
}());
